
import CookieDialog from '~/components/lazyloads/dialogs/CookieDialog.vue'

export default {
  name: 'Accessibility',

  layout: 'layout-meta',

  components: {
    CookieDialog,
  },

  transition: 'myuse-fade',

  async asyncData({ $content }) {
    const page = await $content(
      'privacy/accessibility-statement'
    ).fetch()

    return {
      page,
    }
  },

  data: () => ({
    page: false,
    showBtn: false,
  }),

  methods: {
    getPos(id) {
      try {
        const ref =
          this.$refs[id]

        if (
          Array.isArray(ref) &&
          ref.length
        ) {
          return ref[0].offsetTop
        }

        if (ref) {
          return ref.offsetTop
        }

        return 0
      } catch (_) {
        return 0
      }
    },

    scrollTo(id) {
      try {
        window.scrollTo({
          top:
            this.getPos(id) -
            80,
          behavior: 'smooth',
        })
      } catch (_) {}
    },

    onScroll() {
      if (
        !this.page ||
        !Array.isArray(
          this.page.sections
        ) ||
        !this.page.sections.length
      ) {
        this.showBtn = false
        return
      }

      const topSection =
        this.page.sections[0].id

      this.showBtn =
        window.scrollY >
        this.getPos(topSection)
    },
  },
}
